'use client'
import { type FC, type ReactNode } from 'react'
import StyledComponentsRegistry from '@/utils/base/styled-components-registry'
import { ThemeProvider } from 'styled-components'
import { Susy, theme } from '@/styles'
import { ModalsProvider, ShouldDisplayAnimationProvider, TransitionToSuiteProvider, PageTransitionProvider } from '@/context'
import { Navbar } from './project/Navbar'
import { Footer } from './project/Footer'
import { PRO, STAGING } from '@/utils'
import { PreFooter } from './project/PreFooter'
import dynamic from 'next/dynamic'
// import { BannerBenefits } from './project/BannerBenefits'
import { TransitionWrapper } from './project/TransitionWrapper'
import { BookMobile } from './project/BookMobile'
import { BaseUrlNavigationManager } from '@/managers'

const DynamicEntryAnimation = dynamic(() => import('./project/EntryAnimation').then(mod => mod.EntryAnimation))
const DynamicTransitionToSuite = dynamic(() => import('./project/TransitionToSuite').then(mod => mod.TransitionToSuite), { ssr: false })
const DynamicModalMenu = dynamic(() => import('../components/base/modals/ModalMenu').then(mod => mod.ModalMenu), { ssr: false })
const DynamicModalBenefits = dynamic(() => import('../components/base/modals/ModalBenefits').then(mod => mod.ModalBenefits), { ssr: false })
const DynamicModalPopUp = dynamic(() => import('../components/base/modals/ModalPopUp').then(mod => mod.ModalPopUp), { ssr: false })

type Props = {
  children: ReactNode
}

const ClientProviders:FC<Props> = ({ children }) => {
  return (
    <StyledComponentsRegistry>
			<ThemeProvider theme={theme}>
				<ModalsProvider>
					<ShouldDisplayAnimationProvider>
						<PageTransitionProvider>
							<TransitionToSuiteProvider>
								{/* <BannerBenefits /> */}
								<Navbar />
								<DynamicEntryAnimation />
								<TransitionWrapper>
									{children}
								</TransitionWrapper>
								<DynamicTransitionToSuite />
								<DynamicModalBenefits />
								<DynamicModalMenu />
								<DynamicModalPopUp />
								<BookMobile />
								<PreFooter />
								<Footer />
								<BaseUrlNavigationManager />
							</TransitionToSuiteProvider>
						</PageTransitionProvider>
					</ShouldDisplayAnimationProvider>
				</ModalsProvider>
			</ThemeProvider>
      {(!STAGING && !PRO) && <Susy />}
    </StyledComponentsRegistry>
  )
}

export default ClientProviders
